// import VideoTemplate from '../../../component/template/VideoTemplate.js'
import Webview from "../../../component/native/visible/Webview";
import PlayerView from "../../../component/native/visible/PlayerView";
import App from "../../../App";
import {getFilePathByRemoteUrl} from '@src/common/util'
import Dialog from "../../../component/visible/Dialog"
import SimpleBanner from "../../../component/visible/SimpleBanner"
import Message from '../../../../class/Message'
import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate";

import FrameMessage from '../../../../class/FrameMessage/index'
import IframeView from "../../../component/visible/Container";

export default class IframeSingleDemo extends SingleOfferTemplate {
    constructor(...props) {
        super(...props);

        (function(){
            var timer = 1
            /*window.addEventListener('message', (e)=>{
                console.log("iframe 获取到 message====>",e, location.href)
                const {action, data} = e.data
                if(action==='mofClick'){
                    document.getElementById('msg').innerHTML += (data.msg+' '+timer+'<br/>')
                    console.log('大模版发来数据：', data.initData, data)
                    timer++
                }
            })*/
        })();
        document.body.addEventListener('touchstart', ()=>{
            /*parent.postMessage({
                action: 'subClick',
                data: '子模版向大模版发送消息'
            }, '*')*/

            //FrameMessage.emitMessageToSuperView('testMsg', {msg: 'hei!'})
            //Message.broadcast('testMsg', {msg: 'gegege22'})

        }, false)



        /*FrameMessage.onBroadcast('testMsg', data=>{
            document.getElementById('msg').innerHTML += (data.msg+' nice <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })
        FrameMessage.onSuperViewEmitMessage('testMsg', data=>{
            document.getElementById('msg').innerHTML += (data.msg+' nice super <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })*/

        const toSuperBtn = document.querySelector('.btn-set .toSuper')
        const toSubBtn = document.querySelector('.btn-set .toSub')
        const broadcastBtn = document.querySelector('.btn-set .broadcast')
        const clearBtn = document.querySelector('.btn-set .clear')

        toSuperBtn && toSuperBtn.addEventListener('touchstart', ()=>{
            FrameMessage.emitMessageToSuperView('testMsg', {msg: 'sub to super!'})
        }, false)
        toSubBtn && toSubBtn.addEventListener('touchstart', ()=>{
            FrameMessage.emitMessageToView(this.subTpl, 'testMsg', {msg: 'to tplA'})
            FrameMessage.emitMessageToView(this.subTpl2, 'testMsg', {msg: 'to tplB'})
        }, false)
        broadcastBtn && broadcastBtn.addEventListener('touchstart', ()=>{
            FrameMessage.broadcast('testMsg', {msg: 'broadcast'})
        }, false)
        clearBtn && clearBtn.addEventListener('touchstart', ()=>{
            FrameMessage.broadcast('clearMsg', {msg: 'clearMsg'})
        }, false)



        FrameMessage.onBroadcast('testMsg', data=>{
            document.getElementById('msg').innerHTML += ('广播: '+data.msg+' <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })
        FrameMessage.onMessage('testMsg', data=>{
            document.getElementById('msg').innerHTML += ('onMsg: '+data.msg+' <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })
        FrameMessage.onSuperViewEmitMessage('testMsg', data=>{
            document.getElementById('msg').innerHTML += ('super: '+data.msg+' <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })
        FrameMessage.onSubViewEmitMessage('testMsg', data=>{
            document.getElementById('msg').innerHTML += ('sub: '+data.msg+' <br/>')
            //console.log('大模版发来数据：', data.initData, data)
        })
        FrameMessage.onBroadcast('clearMsg', data=>{
            document.getElementById('msg').innerHTML = ('log: <br/>')
        })
    }


    initComponents() {
        super.initComponents()

        /*let campaign = this.campaign
        let subTplURL = campaign && campaign.rv && campaign.rv.template_url

        //subTplURL+= '&createByIframe=true'
        this.subTpl = new IframeView()
        IframeView.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting, App.initData)
            .then(loadParams=>{
                console.log('11211获取到load campaign参数：', loadParams,location.href)
                console.log('获取到load campaign参数：', loadParams)
                this.subTpl.load(loadParams, this.getSlotById('slot_1'))
            })
        */
    }

    adShowed() {
        super.adShowed()
        // this.playerView.play()
    }

    bindPageEvent() {
        super.bindPageEvent()
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {

    }

    initSlots() {
        super.initSlots()

    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()

    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish(),
        ])
    }
}